import React from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import SuccessStories from '../components/SuccessStories';
import Footer from '../components/Footer';

interface LandingPageProps {
  onBooksClick: () => void;
  onVideoLearningClick: () => void;
  onBlogsClick: () => void;
  onFaqClick: () => void;
  onFeedbackClick?: () => void;
  onLoginClick: () => void;
  onAdminClick: () => void;
  onMkAcademyOnlineClick?: () => void;
  onMkAcademyInPersonClick?: () => void;
  isAuthenticated?: boolean;
  isAdmin?: boolean;
  user?: any;
  onLogout?: () => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ 
  onBooksClick, 
  onVideoLearningClick, 
  onBlogsClick, 
  onFaqClick,
  onFeedbackClick,
  onLoginClick, 
  onAdminClick,
  onMkAcademyOnlineClick,
  onMkAcademyInPersonClick,
  isAuthenticated,
  isAdmin,
  user,
  onLogout
}) => {
  const scrollToSection = (sectionId: string): void => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleHomeClick = (): void => {
    // Scroll to top of the page
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <Header 
        onHomeClick={handleHomeClick} 
        onBooksClick={onBooksClick} 
        onVideoLearningClick={onVideoLearningClick} 
        onBlogsClick={onBlogsClick} 
        onLoginClick={onLoginClick} 
        onAdminClick={onAdminClick}
        onMkAcademyOnlineClick={onMkAcademyOnlineClick}
        onMkAcademyInPersonClick={onMkAcademyInPersonClick}
        isAuthenticated={isAuthenticated}
        isAdmin={isAdmin}
        user={user}
        onLogout={onLogout}
        currentPage="home"
      />
      <Hero 
        onOurPromiseClick={() => scrollToSection('our-promise')} 
        onSuccessStoriesClick={() => scrollToSection('success-stories')}
        onBooksClick={onBooksClick}
        onVideoLearningClick={onVideoLearningClick}
        onBlogsClick={onBlogsClick}
        onMkAcademyOnlineClick={onMkAcademyOnlineClick}
      />
      <Services 
        onBooksClick={onBooksClick}
        onVideoLearningClick={onVideoLearningClick}
        onBlogsClick={onBlogsClick}
        onMkAcademyOnlineClick={onMkAcademyOnlineClick}
      />
      <SuccessStories onHomeClick={handleHomeClick} />
      <Footer 
        onBooksClick={onBooksClick}
        onVideoLearningClick={onVideoLearningClick}
        onBlogsClick={onBlogsClick}
        onFaqClick={onFaqClick}
        onFeedbackClick={onFeedbackClick}
        onMkAcademyOnlineClick={onMkAcademyOnlineClick}
      />
    </>
  );
};

export default LandingPage; 